"use client";
import React, { useRef, useState } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import cn from "clsx";

import styles from "./RealImpactStories.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";


const stories = [
  {
    id: "deepankar-chaudhary",
    name: "Deepankar Chaudhary",
    role: "FPNA Specialist at Accenture",
    company: "Accenture",
    companyLogo: "https://amityonline.com/_v5/Frame_1984078030_770098c24f.webp",
    quote:
      "The career mentoring and practical guidance made all the difference. I was able to approach interviews with confidence and secure the role I aspired to.",
    degree: "MBA, International Business",
    image: "https://amityonline.com/_v5/Photo_Wrap_4cc447cce4.webp",
    borderColor:"#A834A6",
    MwebImage:"https://amityonline.com/_v5/Portrait_5652a94d63.webp"
  },
  {
    id: "meghna-kharera",
    name: "Meghna Kharera",
    role: "Senior Consultant at Microsoft",
    company: "Microsoft",
    companyLogo: "https://amityonline.com/_v5/Frame_1984078030_1_b7ef977924.webp",
    quote: `From building a stronger resume to interview preparation, every step of the career support journey helped me achieve my goals.`,
    degree: "MBA, Information Technology",
    image: "https://amityonline.com/_v5/Portrait_1d6a3609b3.webp",
    MwebImage:"https://amityonline.com/_v5/Portrait_1_17e12e0719.webp",
    borderColor:"#01A3EE"
  },
  {
    id: "Deepanshi Suri ",
    name: "Deepanshi Suri ",
    role: "Manager at Kotak Mahindra Life",
    company: "Kotak Mahindra Life",
    companyLogo: "https://amityonline.com/_v5/Frame_1984078030_2_6850b32124.webp",
    quote:`I stepped out of my comfort zone - and it changed everything.`,
    degree: "MCA, 2022-25",
    image: "https://amityonline.com/_v5/Photo_Wrap_1_9fc8c2c01e.webp",
    borderColor:"#EF3238",
    MwebImage:"https://amityonline.com/_v5/Portrait_2_0bc2d339e3.webp"
  },
  {
    id: "Divya Chougule",
    name: "Divya Chougule",
    role: "Deputy Manager at ICICI Bank",
    company: "ICICI Bank",
    companyLogo: "https://amityonline.com/_v5/Frame_1984078030_3_50b02b0ab9.webp",
    quote:`I stepped out of my comfort zone - and it changed everything.`,
    degree: "MBA, 2016-18",
    image: "https://amityonline.com/_v5/Portrait_1_3fb3153cd1.webp",
    borderColor:"#F9520C",
    MwebImage:"https://amityonline.com/_v5/Portrait_3_6ba49d49ee.webp"
  },
  {
    id: "Devanshi Jora",
    name: "Devanshi Jora",
    role: "IT Specialist at HCL Tech",
    company: "HCL Tech",
    companyLogo: `https://amityonline.com/_v5/Frame_1984078030_4_e7f30d2b08.webp`,
    quote:`I stepped out of my comfort zone - and it changed everything.`,
    degree: "BCA, 2022-25",
    image: "https://amityonline.com/_v5/Photo_Wrap_2_7e780656ca.webp",
    borderColor:"#0F5FDC",
    MwebImage:"https://amityonline.com/_v5/Portrait_4_32b204a84b.webp"
  },
];

function CompanyBadge({ company, logo }: { company: string; logo: string | null }) {
  if (logo) {
    return <img src={logo} alt={company} className={styles.companyLogoImg} />;
  }
  return <span className={styles.companyLogoText}>{company}</span>;
}

export default function RealImpactStories({isMobile=false}) {
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const sliderRef = useRef(null);

  const handleSlideChange = (swiper) => {
    setIsAtStart(swiper.isBeginning);
    setIsAtEnd(swiper.isEnd);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Real Impact. Real Stories. Worldwide.</h2>

      <div
        className={cn(styles.carouselWrapper)}>
        <Swiper
          ref={sliderRef}
          modules={[Navigation, Pagination, Autoplay]}
          navigation={false}
          pagination={{ clickable: true, el: `.${styles.pagination}` }}
          autoplay={{ delay: 500000, disableOnInteraction: false }}
          slidesPerView={1.1}
          spaceBetween={16}
          className={cn("Carousel__blueBullet", styles.swiper)}
          breakpoints={{
            768: {
              slidesPerView: 1.1,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 2.1,
              spaceBetween: 32,
            },
          }}
          onSlideChange={handleSlideChange}
          onReachBeginning={() => setIsAtStart(true)}
          onReachEnd={() => setIsAtEnd(true)}
        >
          {stories.map((story, index) => (
            <SwiperSlide key={story.id}>
              {({ isActive }) => (
                <div
                  className={cn(styles.card, isActive && styles.cardActive)}
                  style={
                    {
                      "--story-color": story.borderColor,
                    } as React.CSSProperties
                  }
                >
                  <div className={styles.avatarWrapper}>
                    <img
                      src={isMobile?story.MwebImage:story.image}
                      alt={story.name}
                      className={styles.avatar}
                    />
                  </div>

                  <div className={styles.body}>
                    <div className={styles.headerRow}>
                      <div>
                        <p className={styles.name}>{story.name}</p>
                        <p className={styles.role}>{story.role}</p>
                      </div>
                      <CompanyBadge
                        company={story.company}
                        logo={story.companyLogo}
                      />
                    </div>

                    <p className={styles.quote}>&ldquo;{story.quote}&rdquo;</p>

                    <div className={styles.footer}>
                      <svg
                        className={styles.capIcon}
                        width="18"
                        height="18"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.8331 5.83302V9.33342M3.50055 7.29152V9.33342C3.50055 9.7976 3.86927 10.2428 4.52559 10.571C5.18192 10.8992 6.07208 11.0836 7.00027 11.0836C7.92845 11.0836 8.81862 10.8992 9.47494 10.571C10.1313 10.2428 10.5 9.7976 10.5 9.33342V7.29152M12.4947 6.37112C12.5991 6.32505 12.6877 6.24935 12.7496 6.1534C12.8114 6.05745 12.8437 5.94546 12.8425 5.83132C12.8414 5.71718 12.8067 5.60589 12.7429 5.51124C12.6791 5.41659 12.589 5.34273 12.4836 5.29883L7.48428 3.02124C7.33229 2.9519 7.16719 2.91602 7.00015 2.91602C6.8331 2.91602 6.668 2.9519 6.51602 3.02124L1.51725 5.2965C1.41341 5.34199 1.32507 5.41676 1.26304 5.51166C1.20101 5.60657 1.16797 5.7175 1.16797 5.83089C1.16797 5.94428 1.20101 6.05521 1.26304 6.15012C1.32507 6.24503 1.41341 6.3198 1.51725 6.36529L6.51602 8.64521C6.668 8.71455 6.8331 8.75043 7.00015 8.75043C7.16719 8.75043 7.33229 8.71455 7.48428 8.64521L12.4947 6.37112Z"
                          stroke="#8C736C"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>

                      <span>{story.degree}</span>
                    </div>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className={styles.paginationRow}>
        <button
          type="button"
          aria-label="Previous story"
          className={cn(styles.navButton, styles.navPrev)}
          disabled={isAtStart}
          onClick={() => (sliderRef.current as any)?.swiper?.slidePrev()}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
            <path
              d="M15 6l-6 6 6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className={styles.pagination} />

        <button
          type="button"
          aria-label="Next story"
          className={cn(styles.navButton, styles.navNext)}
          disabled={isAtEnd}
          onClick={() => (sliderRef.current as any)?.swiper?.slideNext()}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
            <path
              d="M9 6l6 6-6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
